// extracted by mini-css-extract-plugin
export default {"simulation-box":"Simulation_simulation-box__6+FJ6","simulation-content-wrap":"Simulation_simulation-content-wrap__APVkO","simulation-content":"Simulation_simulation-content__zXz3J"};